module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAATCAYAAACORR0GAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAElSURBVHgBvVTbkcIwDJQz/F9KoASug9ABV8HRwXEVYCoAKqAE6IB0AB2EDoAKxG5QIJPhYR5mZ2TZ8WOtlRwngKr24H5hqbwfU+fcwoGkg8FK4qKboOlJfGQkyiU+8rKFfF7jYAsbVCRt8x1Yoe9Docf8lxwt+D46X6iMf/guxjNqKq8hh/0YyRhun9jEgDdgB4QkG8nzGNkZfCpLni3G6BvhZva9bxqHYlvbmzX2+muFMLQNbQ3L20rPuR5emPfJlfBJPrf+N2x6QyrOUaod9lAqf3GV3i7tonbT5rpT6er9ivUhb6h+IKWcm1Wl+6f3cxlEVGEMS2tKpPYtBL4l4WBUrMS1jRlR8N/+ESKxgzN5Aol8CCRaS3xsyha6TzQOWI2eHAe8ehS/ryPgIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-images/email.png
// module id = zeGb
// module chunks = 1